import { render } from "./InputComponent.vue?vue&type=template&id=496b2663&scoped=true"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"

import "./InputComponent.vue?vue&type=style&index=0&id=496b2663&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496b2663"]])

export default __exports__